import { useState } from "react";
import { Camera, Trash } from "@phosphor-icons/react";
import { toast } from "sonner";
import { API, api, errMsg } from "../lib/api";

export const SchoolMark = ({ school, className = "h-8 w-8", fallback = null, testid }) => (
  school?.has_logo
    ? <img src={`${API}/school/logo?v=${encodeURIComponent(school.logo_version || "")}`} alt={`${school.name} logo`} className={`object-contain ${className}`} data-testid={testid} />
    : fallback
);

const initials = (name = "") => {
  const p = name.split(/\s+/).filter(Boolean);
  return ((p[0]?.[0] || "") + (p.length > 1 ? p[p.length - 1][0] : "")).toUpperCase() || "?";
};

export const PersonPhoto = ({ kind, person, className = "h-9 w-9 text-xs", testid }) => (
  person?.has_photo
    ? <img src={`${API}/photos/${kind}/${person.id}.png?v=${encodeURIComponent(person.photo_version || "")}`} alt={person.name}
        className={`shrink-0 rounded-full object-cover ring-2 ring-white/10 ${className}`} data-testid={testid} />
    : <span className={`grid shrink-0 place-items-center rounded-full bg-gradient-to-br from-blue-500/70 to-orange-400/70 font-display font-semibold text-white ring-2 ring-white/10 ${className}`} data-testid={testid}>
        {initials(person?.name)}
      </span>
);

export function PhotoEditor({ kind, person, onChange, testid = "photo" }) {
  const [busy, setBusy] = useState(false);
  const run = async (fn, msg, has) => {
    setBusy(true);
    try {
      await fn();
      toast.success(msg);
      onChange(has);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const upload = (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    run(() => api.put(`/photos/${kind}/${person.id}`, fd), "Photo saved", true);
  };
  return (
    <div className="flex items-center gap-4" data-testid={`${testid}-editor`}>
      <PersonPhoto kind={kind} person={person} className="h-20 w-20 text-2xl" testid={`${testid}-preview`} />
      <div className="flex flex-wrap gap-2">
        <label className={`btn-ghost cursor-pointer !py-1.5 !px-3 ${busy ? "opacity-60" : ""}`} data-testid={`${testid}-upload-btn`}>
          <Camera size={15} /> {person.has_photo ? "Change photo" : "Add photo"}
          <input type="file" accept="image/png,image/jpeg,image/webp" className="hidden" disabled={busy}
            onChange={(e) => { upload(e.target.files[0]); e.target.value = ""; }} data-testid={`${testid}-file-input`} />
        </label>
        {person.has_photo && (
          <button className="btn-ghost !py-1.5 !px-3 !text-rose-300" disabled={busy} onClick={() => run(() => api.delete(`/photos/${kind}/${person.id}`), "Photo removed", false)} data-testid={`${testid}-remove-btn`}>
            <Trash size={15} /> Remove
          </button>
        )}
      </div>
    </div>
  );
}
